const phone = 640;
const tablet = 768;
const desktop = 1024;

export default { phone, tablet, desktop };
